export default __webpack_public_path__ + "8bca82ad8041b2ce2514e7ca3e180130.svg";